import type { RoomInfo } from '@sokdaq/protocol';
import { apiUrl } from './endpoint.js';

/** 입장 전에 보여줄 방 정보. 서버는 ownerId를 빼고 준다. */
export type PublicRoomInfo = Omit<RoomInfo, 'ownerId'>;

export interface CreatedRoom {
  readonly code: string;
  readonly roomId: string;
  readonly name: string;
}

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function createRoom(name: string): Promise<CreatedRoom> {
  const response = await fetch(apiUrl('/api/rooms'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });

  if (!response.ok) throw new ApiError(await errorMessage(response), response.status);
  return response.json() as Promise<CreatedRoom>;
}

export async function lookupRoom(code: string): Promise<PublicRoomInfo> {
  const response = await fetch(apiUrl(`/api/rooms/${encodeURIComponent(code)}`));

  if (response.status === 404) throw new ApiError('그런 방이 없습니다. 초대코드를 확인해 주세요', 404);
  if (!response.ok) throw new ApiError(await errorMessage(response), response.status);
  return response.json() as Promise<PublicRoomInfo>;
}

async function errorMessage(response: Response): Promise<string> {
  try {
    const body = (await response.json()) as { error?: unknown };
    if (typeof body.error === 'string') return body.error;
  } catch {
    // 본문이 JSON이 아니면 상태 코드로만 안내한다.
  }
  return `서버 오류 (${response.status})`;
}
